/**
 * Estado da faixa do banner (§12.5 bar; docs/DECISOES.md §77), num arquivo à parte: a faixa viva (app/partnerLive.tsx)
 * escreve; o slot (app/partnerSlot.tsx) lê, e 'off' recolhe a caixa reservada.
 */
import { signal } from '@preact/signals';

export type PartnerBarState = 'pending' | 'on' | 'off';

export const partnerBarState = signal<PartnerBarState>('pending');
